import { Referral } from '@invoice-simple/common';
import { Platform } from '@invoice-simple/is-events';

import Rollbar from 'src/analytics/rollbar';
import UserModel from 'src/models/UserModel';
import { API_V3_BASE_PATH, client } from './httpClient';

const FRIENDBUY_ENDPOINT = `${API_V3_BASE_PATH}/friendbuy`;

export const trackFriendbuySignup = async (user: UserModel) => {
  try {
    const referralCode = user.advocateReferralCode;

    if (referralCode) {
      user.events.trackAction('referral-action', {
        action: 'signup',
        platform: Platform.web,
        'referral-code': referralCode,
        'referral-email': user.email
      });
    }

    const { baseURL, headers } = user.getApiV3ReqOpts();

    const path = `${baseURL}${FRIENDBUY_ENDPOINT}/signup`;

    await client.post(path, { referralCode }, { headers });
  } catch (err) {
    Rollbar.trackError('Error tracking friendbuy signup', err);
  }
};

export const getReferralData = async (user: UserModel) => {
  try {
    const { baseURL, headers } = user.getApiV3ReqOpts();

    const path = `${baseURL}${FRIENDBUY_ENDPOINT}/referral`;

    const { data }: { data: Referral } = await client.get(path, { headers });

    return data;
  } catch (err) {
    Rollbar.trackError('Error getting referral data', err);
    return;
  }
};
